import { type I18n, type MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import { GetBookingDataPaymentStatus } from "@/shared/api/generated/schemas";

export const bookingPaymentStatusLabels: Record<
  Exclude<GetBookingDataPaymentStatus, null>,
  MessageDescriptor
> = {
  unpaid: msg`Ubetalt`,
  invoicesent: msg`Faktura sendt`,
  invoicepaid: msg`Faktura betalt`,
  cashpaid: msg`Kontant betalt`,
} as const;

export const bookingPaymentStatusOptions = (i18n: I18n) =>
  Object.values(GetBookingDataPaymentStatus).map((value) => ({
    value,
    label: i18n.t(bookingPaymentStatusLabels[value]),
  }));
